/**
 * Centralized message strings for the Yukon web interface
 */

export const messages = {
  // Activity messages
  activity: {
    freeze: (user: string, owner: string, repo: string) => `${user} froze ${owner}/${repo}`,
    unfreeze: (user: string, owner: string, repo: string) => `${user} unfroze ${owner}/${repo}`,
  },

  // Status messages
  status: {
    frozen: '🧊 Frozen',
    notFrozen: '✅ Active',
    loading: 'Loading...',
    connected: 'Connected',
    disconnected: 'Disconnected',
  },

  // Success messages
  success: {
    frozen: 'Repository frozen successfully',
    unfrozen: 'Repository unfrozen successfully',
  },

  // Error messages
  errors: {
    general: 'An error occurred',
    freezeFailed: 'Failed to freeze repository',
    unfreezeFailed: 'Failed to unfreeze repository',
  },

  // SSE event types
  events: {
    repositoryFrozen: 'repository_frozen',
    repositoryUnfrozen: 'repository_unfrozen',
    pullRequest: 'pull_request',
    installationRepositories: 'installation_repositories',
  },
};
